import { Breadcrumbs } from "@amzn/stencil-react-components/breadcrumbs";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Link, LinkIconPosition } from "@amzn/stencil-react-components/link";
import { H1 } from "@amzn/stencil-react-components/text";
import IconExternalLinkSmall from "@amzn/stencil-react-icons/icons/icon-external-link-small";
import React, { FC, ReactNode } from "react";
import { useCrumbClick } from "@/common/hooks/use-crumb-click";
import { Paths } from "@/common/paths/paths";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { IT_SHOP_URL } from "@/config";
import { IT_PORTAL_URL } from "@/common/constants/external-links.constants";

interface OrderTrackingHeaderProps {
  orderNumber: string;
  /** Replaces the default Contact IT support link at the top right. */
  supportLink?: ReactNode;
}

const ContactItSupportLink: FC = () => (
  <Link
    href={IT_PORTAL_URL}
    target="_blank"
    icon={<IconExternalLinkSmall title={getString("orderTracking.opensInNewTab")} />}
    iconPosition={LinkIconPosition.Trailing}
  >
    {getString("orderTracking.supportLink")}
  </Link>
);

export const OrderTrackingHeader: FC<OrderTrackingHeaderProps> = ({ orderNumber, supportLink }) => {
  const onCrumbClick = useCrumbClick();

  return (
    <Col gridGap="S400" width="100%">
      <Breadcrumbs
        crumbs={[
          { title: getString("orderTracking.crumbs.itShop"), url: IT_SHOP_URL },
          { title: getString("orderTracking.crumbs.yourOrders"), url: Paths.orders.url },
          { title: orderNumber },
        ]}
        onCrumbClick={onCrumbClick}
      />
      <Row justifyContent="space-between" alignItems="center" gridGap="S300">
        <H1>{getString("orderTracking.title", { orderNumber })}</H1>
        {supportLink ?? <ContactItSupportLink />}
      </Row>
    </Col>
  );
};
